import { useId } from "react";

import { DiagramFrame } from "@/app/features/diagrams/components/shared/DiagramFrame";
import { StateMachineDrawing } from "@/app/features/diagrams/components/blog/stateMachineVerification/StateMachineDrawing";

export function StateMachineVerificationPipelineVisual() {
  const titleId = useId();
  const descId = useId();

  return (
    <DiagramFrame
      width={740}
      height={470}
      title="Classical State Machine Architecture for AI Agent Pipelines"
      description="Formal state diagram illustrating an agentic pipeline governed by a finite state machine. Shows circular state nodes S0 through S4, clear agent evaluation nodes, deterministic validation gates, a bounded repair loop directly above validation, and terminal success versus human-escalation circuit-breaker states."
      titleId={titleId}
      descId={descId}
      viewBox="0 0 780 500"
      frame={{
        kind: "boundary",
        label: "FINITE STATE MACHINE PIPELINE",
        x: 20,
        y: 20,
        width: 740,
        height: 470,
      }}
    >
      <StateMachineDrawing />
    </DiagramFrame>
  );
}
